export function getMotoTiresQueryKey(width, profile, rim) {
  return `${width}_${profile}_${rim}`;
}

export function shouldLoadMotoTiresForRoute(catalog, width, profile, rim) {
  const tires = (catalog && catalog.motoTires) || [];
  const queryKey = catalog && catalog.motoTiresQueryKey;

  return tires.length === 0 || queryKey !== getMotoTiresQueryKey(width, profile, rim);
}

export function getMotoTirePairsQueryKey(front, rear) {
  return [
    front.width,
    front.profile,
    front.rim,
    rear.width,
    rear.profile,
    rear.rim,
  ].join("_");
}

export function shouldLoadMotoTirePairsForRoute(catalog, front, rear) {
  const queryKey = catalog && catalog.tirePairsQueryKey;

  return queryKey !== getMotoTirePairsQueryKey(front, rear);
}
